import React from "react";
import { useLanguage } from "../../../../contexts";
import "../RiskMatrixGuide/RiskMatrixGuide.scss";
import "./RiskMatrixGeneralGuide.scss";

// URLs oficiales — copiadas del handoff de diseño (design_handoff no genera
// URLs, son las mismas que ya estaban en el prototipo).
const SOURCE_GROUPS = [
  {
    key: "esrs-csrd",
    labelKey: "risk_matrix_sources_esrs_csrd",
    links: [
      { href: "https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=OJ:L_202302772", labelKey: "risk_matrix_sources_eur_lex" },
      { href: "https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32022L2464", labelKey: "risk_matrix_sources_eur_lex" },
    ],
  },
  {
    key: "efrag",
    labelKey: "risk_matrix_sources_efrag",
    links: [
      { href: "https://www.efrag.org/sites/default/files/sites/webpublishing/SiteAssets/IG%201%20Materiality%20Assessment_final.pdf", labelKey: "risk_matrix_sources_official_pdf" },
      { href: "https://www.efrag.org/en/sustainability-reporting", labelKey: "risk_matrix_sources_efrag_hub" },
    ],
  },
  {
    key: "gri",
    labelKey: "risk_matrix_sources_gri",
    links: [{ href: "https://www.globalreporting.org/standards/download-the-standards/", labelKey: "risk_matrix_sources_official_download" }],
  },
  {
    key: "ifrs",
    labelKey: "risk_matrix_sources_ifrs",
    links: [{ href: "https://www.ifrs.org/issued-standards/ifrs-sustainability-standards-navigator/", labelKey: "risk_matrix_sources_ifrs_navigator" }],
  },
  {
    key: "iso",
    labelKey: "risk_matrix_sources_iso",
    links: [
      { href: "https://www.iso.org/standard/68508.html", label: "ISO 14091" },
      { href: "https://www.iso.org/standard/60857.html", label: "ISO 14001" },
    ],
  },
  {
    key: "tcfd",
    labelKey: "risk_matrix_sources_tcfd",
    links: [{ href: "https://www.fsb-tcfd.org/recommendations/", labelKey: "risk_matrix_sources_tcfd_recommendations" }],
  },
];

const CHOOSER_ROWS = [
  { needKey: "risk_matrix_chooser_row1_need", use: "ISO 14001:2015", evaluatesKey: "risk_matrix_chooser_row1_evaluates", source: "ISO 14001 cl. 6.1" },
  { needKey: "risk_matrix_chooser_row2_need", use: "IFRS S2 / TCFD", evaluatesKey: "risk_matrix_chooser_row2_evaluates", source: "IFRS S2 §3, §29(c)" },
  { needKey: "risk_matrix_chooser_row3_need", use: "GRI 3", evaluatesKey: "risk_matrix_chooser_row3_evaluates", source: "GRI 3: Material Topics 2021" },
  { needKey: "risk_matrix_chooser_row4_need", use: "ISO 14091:2021", evaluatesKey: "risk_matrix_chooser_row4_evaluates", source: "ISO 14091" },
  { needKey: "risk_matrix_chooser_row5_need", use: "ESRS", evaluatesKey: "risk_matrix_chooser_row5_evaluates", source: "ESRS 1 · EFRAG IG 1" },
  { needKey: "risk_matrix_chooser_row6_need", use: "Leopold 1971", evaluatesKey: "risk_matrix_chooser_row6_evaluates", source: "USGS Circular 645 (1971)" },
  { needKey: "risk_matrix_chooser_row7_need", use: "Conesa 1997", evaluatesKey: "risk_matrix_chooser_row7_evaluates", source: "Conesa (1997)" },
];

export function RiskMatrixGeneralGuide({ onBack }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <div className="risk-matrix-guide risk-matrix-general-guide">
      <button type="button" className="risk-matrix-general-guide__back" onClick={onBack}>
        ← {t("risk_matrix_menu_dashboard")}
      </button>

      <h2>{t("risk_matrix_general_guide_title")}</h2>
      <p>{t("risk_matrix_general_guide_intro")}</p>

      <h3>{t("risk_matrix_chooser_title")}</h3>
      <p>{t("risk_matrix_chooser_intro")}</p>
      <div className="risk-matrix-general-guide__scrollx">
        <table className="risk-matrix-guide__table">
          <thead>
            <tr>
              <th>{t("risk_matrix_chooser_col_need")}</th>
              <th>{t("risk_matrix_chooser_col_use")}</th>
              <th>{t("risk_matrix_chooser_col_evaluates")}</th>
              <th>{t("risk_matrix_chooser_col_source")}</th>
            </tr>
          </thead>
          <tbody>
            {CHOOSER_ROWS.map((row) => (
              <tr key={row.use}>
                <td>{t(row.needKey)}</td>
                <td><b>{row.use}</b></td>
                <td>{t(row.evaluatesKey)}</td>
                <td>{row.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3>{t("risk_matrix_sources_title")}</h3>
      <p>{t("risk_matrix_sources_intro")}</p>
      <ul className="risk-matrix-general-guide__sources">
        {SOURCE_GROUPS.map((group) => (
          <li key={group.key}>
            <b>{t(group.labelKey)}</b>:{" "}
            {group.links.map((link, i) => (
              <React.Fragment key={link.href}>
                {i > 0 && " · "}
                <a href={link.href} target="_blank" rel="noopener noreferrer">
                  {link.label || t(link.labelKey)}
                </a>
              </React.Fragment>
            ))}
          </li>
        ))}
      </ul>
    </div>
  );
}
